module.exports = __webpack_public_path__ + "static/media/kg.e606dee0.jpeg";